export const staticMenuData = {
  success: true,
  data: {
    _id: "66f06960ae8228a2220a0a05",
    menu: [
      {
        type: "item",
        title: "b25bb23c-1284-2814-7222-d1d5a7e514df",
        index: "0",
        title_fr: "Nos services",
        title_en: "Our services",
        href: "/our-expertise",
        href_fr: "/#our-services",
        href_en: "/#our-services"
      },
      {
        type: "item",
        title: "4ff6b943-00c1-b42a-4c08-fb8fac2d3718",
        index: "1",
        title_fr: "Nos projets",
        title_en: "Our projects",
        href: "/vse-sme-solutions",
        href_fr: "/nos-projets-fr",
        href_en: "/our-projects-en"
      },
      {
        type: "item",
        title: "56644279-e690-d1a7-1f45-b8d1b865da69",
        elements: [
          {
            title: "12aef61d-4557-e052-c254-c6c8a6f10b88",
            translation: [
              {
                flag: "/images/flag/FR.svg",
                iSOCode: "fr"
              },
              {
                flag: "/images/flag/UK.svg",
                iSOCode: "en"
              }
            ]
          }
        ],
        title_fr: "Le blog",
        title_en: "The blog",
        href_fr: "/le-blog-fr",
        href_en: "/the-blog-en",
        index: "2"
      },
      {
        type: "item",
        title: "d35f6519-4474-4325-f5ce-ad45d7629230",
        title_fr: "Qui sommes-nous ?",
        title_en: "Who are we ?",
        href_fr: "/qui-sommes-nous-fr",
        href_en: "qui-sommes-nous-en",
        index: "3"
      },
      {
        type: "linkBtn",
        title: "0f41afa8-34b3-6e12-5fe3-805eea4fcfa5",
        index: "4",
        title_fr: "Nous contacter",
        title_en: "Contact us",
        href: "/contact",
        href_fr: "/contact-fr",
        href_en: "/contact-en"
      },
      {
        type: "dropdown",
        elements: [
          {
            title: "6f04f7b5-a4e1-20e6-ed77-27f56d32c5f5",
            href: "#",
            icon: "/images/flag/FR.svg",
            isSelected: "false",
            iSOCode: "fr",
            translation: [
              {
                title: "Français",
                flag: "/images/flag/FR.svg",
                iSOCode: "fr"
              },
              {
                title: "Français",
                flag: "/images/flag/UK.svg",
                iSOCode: "en"
              }
            ],
            href_fr: "#",
            href_en: "#"
          },
          {
            title: "8c313f8c-b4da-f84b-6004-224aa4868a20",
            href: "#",
            icon: "/images/flag/UK.svg",
            isSelected: "true",
            iSOCode: "en",
            translation: [
              {
                title: "English",
                flag: "/images/flag/FR.svg",
                iSOCode: "fr"
              },
              {
                title: "English",
                flag: "/images/flag/UK.svg",
                iSOCode: "en"
              }
            ],
            href_fr: "#",
            href_en: "#"
          }
        ],
        style: "lang"
      }
    ],
    updated_at: "2024-10-22T08:07:30.387000Z",
    created_at: "2024-09-22T19:00:48.832000Z"
  },
  message: 200
};

export const staticFooterData = {
  success: true,
  data: {
    _id: "66f06960ae8228a2220a0a04",
    footer: [
      {
        type: "link",
        title: "49e37735-a35d-9be0-c38e-c7924c0db899",
        elements: [
          {
            title: "1675bac0-6ce3-2bfc-6513-e879a0cff41d",
            href: "/contact-us",
            translation: [
              {
                flag: "/images/flag/FR.svg",
                iSOCode: "fr",
                title: "Mentions légales"
              },
              {
                flag: "/images/flag/UK.svg",
                iSOCode: "en",
                title: "Legal Notice"
              }
            ],
            href_fr: "/contact-us",
            href_en: "/contact-us"
          },
          {
            title: "ef704acf-1cfe-90ff-ee3a-cb81f76a4b4f",
            translation: [
              {
                title: "Politique de confidentialité",
                flag: "/images/flag/FR.svg",
                iSOCode: "fr"
              },
              {
                title: "Privacy Policy",
                flag: "/images/flag/UK.svg",
                iSOCode: "en"
              }
            ],
            href_fr: "/contact-us",
            href_en: "/contact-us"
          }
        ],
        index: "0",
        title_fr: "HOME",
        title_en: "HOME"
      }
    ],
    updated_at: "2024-09-22T19:00:48.809000Z",
    created_at: "2024-09-22T19:00:48.809000Z"
  },
  message: 200
}; 